module.exports = __webpack_public_path__ + "static/media/buy_pause_payment_6.426de4bc.jpg";